/**
 * Live Trading V3 — client-side Attack constants, in a PURE module.
 *
 * Deliberately store-free: the target derivation (attackTarget.ts) is
 * imported by card resolvers all over the trading views, and pulling the
 * attack STORE graph (zustand + the one-click subscription) into every one
 * of those import chains made isolated test mocks of the one-click store
 * impossible. Mirrors of the relay's attackPolicy values; the relay
 * enforces regardless.
 */
export const ATTACK_MAX_CONTRACTS = 1_000;
export const ATTACK_FALLBACK_MAX_CONTRACTS = 100;
export const ATTACK_DEFAULT_CONTRACTS = 25;
/** The one accepted depth in this release (see relay attackPolicy). */
export const ATTACK_DEPTH_CONTRACT = 1;
